import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import * as Request from "../entries/common/request";
import { BaseApi } from "../core/base-api";
import { makeMethod, makeDataMethod } from "../core/base-api/methods-maker";
import { createCommentsApiClass } from "./_partials/comments";
var VideoCommentsApi = createCommentsApiClass({
  basePath: Request.Videos.Paths.Show
});
export var VideosApi = /*#__PURE__*/function (_BaseApi) {
  _inherits(VideosApi, _BaseApi);

  var _super = _createSuper(VideosApi);

  function VideosApi(config) {
    var _this;

    _classCallCheck(this, VideosApi);

    _this = _super.call(this, config);
    _this.comments = void 0;
    _this.comments = new VideoCommentsApi(config);
    return _this;
  }

  return VideosApi;
}(BaseApi);
VideosApi.prototype.show = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.Show
});
VideosApi.prototype.listRecommended = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.ListRecommended
});
VideosApi.prototype.listRelatedEndpoints = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.ListRelatedEndpoints
});
VideosApi.prototype.listRelated = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.ListRelated
});
/**
 * get a request token for access to sources for this given video
 */

VideosApi.prototype.getToken = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.GetToken,
  interceptor: {
    request: function request(config) {
      var _ref = config.params,
          deviceId = _ref.deviceId;
      delete config.params.deviceId;
      config.headers['X-Device-Id'] = deviceId;
      return config;
    }
  }
});
/**
 * Returns sources for video (used for all clients)
 */

VideosApi.prototype.getSources = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.GetSources,
  interceptor: {
    request: function request(config) {
      var params = config.params;
      var deviceId = params.deviceId;
      delete params.deviceId;
      config.headers['X-Device-Id'] = deviceId;
      var sourceToken = params.sourceToken;
      delete params.sourceToken;
      config.headers['X-Vs-Source-Token'] = sourceToken;
      return config;
    }
  }
});
/**
 * Show video availability status based on region content rating
 */

VideosApi.prototype.getCanWatch = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.GetCanWatch,
  needAuth: true
});
/**
 * Show video availability status based on region content rating
 */

VideosApi.prototype.getCanWatchWithPin = makeDataMethod({
  method: 'post',
  path: Request.Videos.Paths.GetCanWatchWithPin,
  needAuth: true
});
/**
 * check if existing user has followed this video
 */

VideosApi.prototype.getInteractions = makeMethod({
  method: 'get',
  path: Request.Videos.Paths.GetInteractions,
  needAuth: true
});
/**
 * like the video [WIP]
 */

VideosApi.prototype.like = makeDataMethod({
  method: 'put',
  path: Request.Videos.Paths.Like,
  needAuth: true
});
/**
 * unlike the video [WIP]
 */

VideosApi.prototype.unlike = makeMethod({
  method: 'delete',
  path: Request.Videos.Paths.Unlike,
  needAuth: true
});
/**
 * create/update review of film by user
 */

VideosApi.prototype.review = makeDataMethod({
  method: 'post',
  path: Request.Videos.Paths.Review,
  needAuth: true
});